import { MenuItemProps } from '../../StylableHorizontalMenu.types';

export const getHasHeadings_column = (item: MenuItemProps) =>
  !!item.items?.some(subItem => !!subItem.items?.length);
